import Entity from './entity'
export default class Thdata extends Entity<number>{
    Path:string;
}